import {Link, NavLink} from 'react-router-dom';

import '../assets/css/footer.css';
import clientconfigwebapp from "../../clientconfigwebapp";
import logo_web_app from '../../assets/images/logo.png';

import Grid from '@mui/material/Grid';
import {Fragment} from "react";

import Footer_Section_Bottom from "./Footer_Section_Bottom";
import Footer_Modal_videobox from "./Footer_Modal_videobox";

const Footercom = () => {
    return (

        <Fragment>

            <div className="footer">


                <div className={"container_bk_home"}>
                    <Grid container direction="row" spacing={10} style={{paddingTop: "14px"}}>


                        <Grid item lg={4} md={4} sm={12} xs={12}>
                            <div className="">
                                <div className="logo-footer-bk"><img src={logo_web_app} alt="logofooter"/></div>
                                <div className="footer-aboutme mt-[9px]">
                                    بازارانو پلتفرم تخصصی خرید و فروش عمده است که با گردآوری هزاران کالای عمده از سراسر ایران، امکان مقایسه و انتخاب آسان را برای خریداران فراهم می‌کند. این پلتفرم با ابزارهای پیشرفته جستجو و فیلترها، خدمات تبلیغاتی، ارتباط سریع و معاملات آنلاین بین خریداران و فروشندگان را تسهیل می‌کند.

                                </div>
                            </div>
                        </Grid>


                        <Grid item lg={2} md={2} sm={6} xs={6}>
                            <div className="box-link-footer">
                                <div className="link-footer-title -mr-[15px]">دسترسی سریع</div>
                                <ul className={"[list-style:disc]"}>
                                    <li><NavLink className={"-mr-[5px]"}  reloadDocument={true} to={"/"}>صفحه اصلی</NavLink></li>
                                    <li><NavLink className={"-mr-[5px]"}  reloadDocument={true} to={"/products"}>محصولات</NavLink></li>
                                    <li><NavLink className={"-mr-[5px]"}  reloadDocument={true} to={"/requirements"}>درخواست های خرید</NavLink>
                                    </li>
                                    <li><NavLink className={"-mr-[5px]"} reloadDocument={true} to={"/login-register"}>فروشنده شوید!</NavLink>
                                    </li>
                                    <li><NavLink className={"-mr-[5px]"} reloadDocument={true} to={"/login-register"}>خریدار شوید!</NavLink>
                                    </li>
                                </ul>
                            </div>
                        </Grid>

                        <Grid item lg={2} md={2} sm={6} xs={6}>
                            <div className="box-link-footer">
                                <div className="link-footer-title -mr-[15px]">دسترسی سریع</div>
                                <ul className={"[list-style:disc]"}>
                                    <li><NavLink className={"-mr-[5px]"} reloadDocument={true} to={"/contact-us"}>تماس
                                        با ما</NavLink></li>
                                    <li><NavLink className={"-mr-[5px]"} reloadDocument={true} to={"/about-us"}>درباره
                                        ما</NavLink></li>
                                    <li><NavLink className={"-mr-[5px]"} reloadDocument={true}
                                                 to={"/services"}>خدمات</NavLink></li>
                                    <li><a className={"-mr-[5px]"} target={"_blank"} href={"https://bazaarano.com/blog/"}>مقالات</a></li>
                                        </ul>
                                        </div>
                                        </Grid>

                                        <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <div className="box-link-footer">
                                            <div className="link-footer-title">تماس با ما</div>
                                            <ul>
                                                <li> تلفن: <a target={"_blank"}
                                                              href={"tel:+989999792212"}>09999792212</a></li>
                                                <li> ایمیل: <a target={"_blank"}
                                                               href={"mailto:info@bazaarano.com"}>info@bazaarano.com</a>
                                                </li>
                                                <li>تهران،سعادت آباد،میدان کاج به سمت بلوار اصلی سعادت آباد</li>
                                            </ul>
                                        </div>
                        </Grid>

                    </Grid>


                </div>


            </div>

            <div className={"container_bk_home bg-[#d8f4fd]"}>
                <div className="flex flex-wrap  justify-center items-center py-[20px]">

                    <div className="w-full lg:w-4/12 text-[12px]">
                        <div style={{
                            "padding-bottom": "20px",
                            "padding-top": "14px",
                            "-webkit-text-align": "center",
                            "text-align": "center",
                            "color": "black",
                            "font-size": "11px",
                            "display": "block",
                            "line-height": "1.6",
                            "border-top": "1px solid rgba(196, 195, 195, 0.21)"
                        }}>کلیه حقوق مادی و معنوی این سایت متعلق بازارانو است.طراحی توسط <a target="_blank"
                                                                                                   className="text-svg-hover-orange-bk"
                                                                                                   href="https://rayanitco.com/"
                                                                                                   title="رایان"
                                                                                                   style={{"color": "blue"}}> رایان </a>
                        </div>
                    </div>

                    <div className="w-full lg:w-4/12">

                        <Footer_Section_Bottom/>

                    </div>

                    <div className="w-full lg:w-4/12 text-[12px] text-left">
                        Copyright © bazaarano
                    </div>


                </div>
            </div>


            <Footer_Modal_videobox/>


        </Fragment>


    )
}
export default Footercom;